// App.jsx
import { useEffect, useState, useRef } from "react";
import Navbar from "./components/Navbar/Navbar.jsx";
import About from "./components/About/About.jsx";
import Products from "./components/Products/Products.jsx";
import Contact from "./components/Contact/Contact.jsx";
import Footer from "./components/Footer/Footer.jsx";
import BlurBlob from './components/BlurBlob.jsx';
import B from './assets/b.png'


const App = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(false);
  const timerRef = useRef(null);

  const isIOS = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent);
  };

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallButton(true);
      console.log('beforeinstallprompt event fired. Install button is now visible.');

      timerRef.current = setTimeout(() => {
        setShowInstallButton(false);
        console.log('PWA install prompt auto-hidden after 8 seconds.');
      }, 8000);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    if (isIOS() && !window.matchMedia('(display-mode: standalone)').matches) {
      setShowInstallButton(true);
      timerRef.current = setTimeout(() => {
        setShowInstallButton(false);
        console.log('iOS install instructions auto-hidden after 8 seconds.');
      }, 8000);
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      setShowInstallButton(false);
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      console.log(`User response to the A2HS prompt: ${outcome}`);
      setDeferredPrompt(null);
    }
  };

  const handleDismissAlert = () => {
    setShowInstallButton(false);
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    console.log('PWA install prompt manually dismissed.');
  };

  return (
    <div className="bg-[#0d081f] relative min-h-screen">

      <BlurBlob position={{ top: '35%', left: '20%' }} size={{ width: '30%', height: '40%' }} />

      <div className="absolute inset-0 bg-[linear-gradient(to_right,#4f4f4f2e_1px,transparent_1px),linear-gradient(to_bottom,#4f4f4f2e_1px,transparent_1px)] bg-[size:14px_24px] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)]"></div>
      
      <div className="relative pt-20">
        <Navbar />
        <About />
        <Products />
        <Contact />
        <Footer />
      </div>

      {/* Conditional PWA Install Button for Android/Desktop */}
      {showInstallButton && !isIOS() && (
        <div className="fixed top-4 left-1/2 -translate-x-1/2 p-4 bg-gray-800 text-white rounded-xl shadow-2xl z-50 flex flex-col items-center justify-center space-y-2 max-w-sm w-11/12 md:w-auto animate-fade-in-up">
          <button
            onClick={handleDismissAlert}
            className="absolute top-2 right-2 text-gray-400 hover:text-white text-lg font-bold"
            aria-label="Dismiss"
          >
            &times;
          </button>
          <p className="text-sm text-center">
            Install <span className="font-bold">Food-Square & RestroApps</span> for a faster and offline-ready experience! {/* MODIFIED TEXT HERE */}
          </p>
          <button
            onClick={handleInstallClick}
            className="w-full bg-gradient-to-r from-yellow-400 to-yellow-600 text-gray-900 font-bold py-3 px-6 rounded-lg shadow-lg hover:from-yellow-500 hover:to-yellow-700 transition duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-opacity-75"
          >
            Install App
          </button>
        </div>
      )}

      {/* Conditional Instructions for iOS users */}
      {isIOS() && showInstallButton && !window.matchMedia('(display-mode: standalone)').matches && (
        <div className="fixed top-4 left-1/2 -translate-x-1/2 p-4 bg-blue-700 text-white rounded-xl shadow-2xl z-50 flex flex-col items-center justify-center space-y-2 max-w-sm w-11/12 md:w-auto animate-fade-in-up">
          <button
            onClick={handleDismissAlert}
            className="absolute top-2 right-2 text-blue-200 hover:text-white text-lg font-bold"
            aria-label="Dismiss"
          >
            &times;
          </button>
          <p className="text-sm text-center">
            For iOS users: Tap the <span className="font-bold">Share</span> button <span className="text-lg">⬆️</span> in your browser's toolbar and then 'Add to Home Screen' to install!
          </p>
        </div>
      )}
    </div>
  );
};

export default App;

// App.jsx
// import { useEffect, useState, useRef } from "react";
// import Navbar from "./components/Navbar/Navbar.jsx";
// import About from "./components/About/About.jsx";
// import Products from "./components/Products/Products.jsx";
// import Contact from "./components/Contact/Contact.jsx";
// import Footer from "./components/Footer/Footer.jsx";
// import BlurBlob from './components/BlurBlob.jsx';
// import B from './assets/b.png' // Your imported background image

// const App = () => {
//   const [deferredPrompt, setDeferredPrompt] = useState(null);
//   const [showInstallButton, setShowInstallButton] = useState(false);
//   const timerRef = useRef(null);

//   const isIOS = () => {
//     const userAgent = window.navigator.userAgent.toLowerCase();
//     return /iphone|ipad|ipod/.test(userAgent);
//   };

//   useEffect(() => {
//     const handleBeforeInstallPrompt = (e) => {
//       e.preventDefault();
//       setDeferredPrompt(e);
//       setShowInstallButton(true);
//       console.log('beforeinstallprompt event fired. Install button is now visible.');

//       timerRef.current = setTimeout(() => {
//         setShowInstallButton(false);
//         console.log('PWA install prompt auto-hidden after 8 seconds.');
//       }, 8000);
//     };

//     window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

//     if (isIOS() && !window.matchMedia('(display-mode: standalone)').matches) {
//       setShowInstallButton(true);
//       timerRef.current = setTimeout(() => {
//         setShowInstallButton(false);
//         console.log('iOS install instructions auto-hidden after 8 seconds.');
//       }, 8000);
//     }

//     return () => {
//       window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
//       if (timerRef.current) {
//         clearTimeout(timerRef.current);
//       }
//     };
//   }, []);

//   const handleInstallClick = async () => {
//     if (deferredPrompt) {
//       setShowInstallButton(false);
//       if (timerRef.current) {
//         clearTimeout(timerRef.current);
//       }
//       deferredPrompt.prompt();
//       const { outcome } = await deferredPrompt.userChoice;
//       console.log(`User response to the A2HS prompt: ${outcome}`);
//       setDeferredPrompt(null);
//     }
//   };

//   const handleDismissAlert = () => {
//     setShowInstallButton(false);
//     if (timerRef.current) {
//       clearTimeout(timerRef.current);
//     }
//     console.log('PWA install prompt manually dismissed.');
//   };

//   return (
//     <div 
//       className="relative min-h-screen bg-cover bg-center"
//       style={{ backgroundImage: `url(${B})` }}
//     >

//       <BlurBlob position={{ top: '35%', left: '20%' }} size={{ width: '30%', height: '40%' }} />

//       <div className="absolute inset-0 bg-[linear-gradient(to_right,#4f4f4f2e_1px,transparent_1px),linear-gradient(to_bottom,#4f4f4f2e_1px,transparent_1px)] bg-[size:14px_24px] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)]"></div>
//       
//       <div className="relative pt-20">
//         <Navbar />
//         <About />
//         <Products />
//         <Contact />
//         <Footer />
//       </div>

//       {/* Conditional PWA Install Button for Android/Desktop */}
//       {showInstallButton && !isIOS() && (
//         <div className="fixed top-4 left-1/2 -translate-x-1/2 p-4 bg-gray-800 text-white rounded-xl shadow-2xl z-50 flex flex-col items-center justify-center space-y-2 max-w-sm w-11/12 md:w-auto animate-fade-in-up">
//           <button
//             onClick={handleDismissAlert}
//             className="absolute top-2 right-2 text-gray-400 hover:text-white text-lg font-bold"
//             aria-label="Dismiss"
//           >
//             &times;
//           </button>
//           <p className="text-sm text-center">
//             Install <span className="font-bold">FoodSquare Restro Apps</span> for a faster and offline-ready experience! {/* MODIFIED TEXT HERE */}
//           </p>
//           <button
//             onClick={handleInstallClick}
//             className="w-full bg-gradient-to-r from-yellow-400 to-yellow-600 text-gray-900 font-bold py-3 px-6 rounded-lg shadow-lg hover:from-yellow-500 hover:to-yellow-700 transition duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-opacity-75"
//           >
//             Install App
//           </button>
//         </div>
//       )}

//       {/* Conditional Instructions for iOS users */}
//       {isIOS() && showInstallButton && !window.matchMedia('(display-mode: standalone)').matches && (
//         <div className="fixed top-4 left-1/2 -translate-x-1/2 p-4 bg-blue-700 text-white rounded-xl shadow-2xl z-50 flex flex-col items-center justify-center space-y-2 max-w-sm w-11/12 md:w-auto animate-fade-in-up">
//           <button
//             onClick={handleDismissAlert}
//             className="absolute top-2 right-2 text-blue-200 hover:text-white text-lg font-bold"
//             aria-label="Dismiss"
//           >
//             &times;
//           </button>
//           <p className="text-sm text-center">
//             For iOS users: Tap the <span className="font-bold">Share</span> button <span className="text-lg">⬆️</span> in your browser's toolbar and then 'Add to Home Screen' to install!
//           </p>
//         </div>
//       )}
//     </div>
//   );
// };

// export default App;